// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Dm-z","tupacHeader":"Em-z","tupacHeader2":"Fm-z","tupacMenu":"Gm-z","tupacMenu2":"Hm-z","tupacMain":"Im-z","tupacMain2":"Jm-z"};